import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getUsersRouterLink} from "root/Wieldy/routePaths";
import {UserTypeFilters, UserTypes, UserTypeTitles} from "root/DataFunctions/Constants";
import {useLocation} from "react-router-dom";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import useModalAddUser from "root/Modals/AddUser/useModalAddUser";
import useModalUpdateChild from "root/Modals/UpdateChildDetails/useModalUpdateChild";
import {useParams} from "react-router";
import phpVars from 'phpVars';
import {useGlobalContext} from "root/contexts/GlobalContext";

const UsersSubmenu = (props ) =>
{
    const {search} = useLocation();

    const { userType } = useGlobalContext() ;

    // Open add user/child modals
    const [renderAddUserModal, showAddUserModal] = useModalAddUser((result) =>
    {
        if (result === 'saved')
        {
            location.replace(location.pathname);
        }
    })

    const [renderAddChildModal, showAddChildModal] = useModalUpdateChild((result) =>
    {
        if (result === 'saved')
        {
            location.replace(location.pathname);
        }
    })

    let { user_type } = useParams();

    const user_filter_type = user_type === undefined ? UserTypeFilters.STAFF : user_type ;
    const isSysAdmin = userType === UserTypes.ADMIN;

    const clickHandler = (event) =>
    {
        switch(event.currentTarget.title){
            case 'Child':
                showAddChildModal(null, 'create');
                break;
            case 'Adult':
                showAddUserModal(null, 'create', null, false);
                break
        }
    }

    const usersSubmenu =() =>{
        return(
            <Fragment>
                <AppSidebarGroup title='Filters' default={user_filter_type}>
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.STAFF)} title={UserTypeTitles.STAFF}  iconName='icon-user-o' name={UserTypeFilters.STAFF}/>
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.CHILDREN)} title={UserTypeTitles.CHILDREN} iconName='icon-user-o' name={UserTypeFilters.CHILDREN} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.FOSTER_CARERS)} title={UserTypeTitles.FOSTER_CARERS}  iconName='icon-user-o' name={UserTypeFilters.FOSTER_CARERS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.FOREVER_PARENTS)} title={UserTypeTitles.FOREVER_PARENTS} iconName='icon-user-o' name={UserTypeFilters.FOREVER_PARENTS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.CONNECTED_CARERS)} title={UserTypeTitles.CONNECTED_CARERS} iconName='icon-user-o' name={UserTypeFilters.CONNECTED_CARERS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.BIRTH_PARENTS)} title={UserTypeTitles.BIRTH_PARENTS}  iconName='icon-user-o' name={UserTypeFilters.BIRTH_PARENTS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.PROFESSIONALS)} title={UserTypeTitles.PROFESSIONALS} iconName='icon-user-o' name={UserTypeFilters.PROFESSIONALS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.OTHERS)} title={UserTypeTitles.OTHERS} iconName='icon-user-o' name={UserTypeFilters.OTHERS} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.ARCHIVED)} title={UserTypeTitles.ARCHIVED} iconName='icon-user-o' name={UserTypeFilters.ARCHIVED} />
                    <AppSidebarMenuItem link={getUsersRouterLink( UserTypeFilters.BLOCKED)} title={UserTypeTitles.BLOCKED} iconName='icon-user-o' name={UserTypeFilters.BLOCKED} />
                </AppSidebarGroup>

                <WieldySidebarSection title='New User' >
                    {!isSysAdmin && <WieldySidebarClick modal={(event) => clickHandler(event)} title='Child' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>}
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Adult' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c2'/>
                </WieldySidebarSection>
            </Fragment>
        )
    }

    return (
        <Fragment>
            { usersSubmenu ()}
            {renderAddUserModal(props)}
            {renderAddChildModal(props)}
        </Fragment>
    )
}

export default UsersSubmenu ;